module.exports = {"232723100":"西林吉镇","232723101":"图强镇","232723102":"阿木尔镇","232723103":"兴安镇","232723104":"北极镇","232723105":"古莲镇","232723400":"西林吉林业局","232723401":"图强林业局","232723402":"阿木尔林业局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/232723.json
// module id = 744
// module chunks = 0